/**
 * Open a server-rendered PDF and trigger the browser's print dialog.
 *
 * Loads the (same-origin) PDF into a hidden iframe and calls `print()` on it once
 * loaded, so the dialog targets the document PDF rather than the app UI. If printing
 * is blocked (some browsers/PDF viewers), falls back to opening the PDF in a new tab.
 */
export function printPdf(url: string): void {
  // Remove any leftover frame from a previous print.
  document.getElementById('print-pdf-frame')?.remove();

  const frame = document.createElement('iframe');
  frame.id = 'print-pdf-frame';
  frame.setAttribute('aria-hidden', 'true');
  frame.style.position = 'fixed';
  frame.style.right = '0';
  frame.style.bottom = '0';
  frame.style.width = '0';
  frame.style.height = '0';
  frame.style.border = '0';
  frame.src = url;

  frame.onload = () => {
    try {
      frame.contentWindow?.focus();
      frame.contentWindow?.print();
    } catch {
      window.open(url, '_blank', 'noopener');
    }
  };

  document.body.appendChild(frame);
}
